import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Button from 'components/common/Button/Button'
import { Input } from 'components/common/FormElements/Input'
import Media from 'components/common/Media'
import { filterProps } from 'helpers/utils'

const propsToRemove = [
  'handleStoreSelected',
  'showStoreLocatorModal',
  'completeStoreSelection'
]

const StoreAddressInput = ({ handleModalOpen, ...props }) =>
  <CompactInput isInvalid={ props.meta.error } { ...filterProps(props, propsToRemove) } >
    <AlignedButton
      type="button"
      aria-invalid={ props.meta.invalid ? 'true' : 'false' }
      aria-label={ props.meta.error ? props.meta.error : undefined }
      narrow
      onClick={ handleModalOpen }>
      Find store
    </AlignedButton>
  </CompactInput>

export default StoreAddressInput

StoreAddressInput.propTypes = {
  handleModalOpen: PropTypes.func,
  meta: PropTypes.shape({
    invalid: PropTypes.bool,
    error: PropTypes.string
  })
}

const AlignedButton = styled(Button)`
  position: relative;
  top: 5px;
  margin-left: 20px;
  height: 30px;
  flex-shrink: 0;
`

const CompactInput = styled(Input)`
  display: inline-flex;
  justify-content: space-between;
  ${Media.mobile`
    display: inline-flex !important;

    ${props => props.isInvalid && css`
      margin-bottom: 50px!important;
    `}

    label[data-error-message="true"] {
      position: absolute;
      margin-top: 5px;
    }
  `}

  & input {
    display: inline-flex;
  }
`
